import React, {useState, useEffect} from "react";
import "../../css/classes/budgetStatsCard.scss";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import ShoppingBagIcon from "@mui/icons-material/ShoppingBag";
import DescriptionIcon from "@mui/icons-material/Description";
import CreditCardIcon from "@mui/icons-material/CreditCard";
import SavingsIcon from "@mui/icons-material/Savings";

// const data = [
//     {
//       title: "Expected Income",
//       label: "Money In",
//       labelColor: "#4ECDC4",
//       expected: "Expected",
//       expectedAmount: 6150.0,
//       progress: 0,
//       progressLabel: "Income under expected",
//       progressAmount: 6150.0,
//       icon: <AttachMoneyIcon style={{ color: "#4ECDC4", fontSize: "20px" }} />,
//       iconBg: "#4ECDC4",
//     },
//     {
//       title: "Expenses Budget",
//       label: "Expenses",
//       labelColor: "#FF6B9D",
//       expected: "Budget",
//       expectedAmount: 3100.0,
//       progress: 0,
//       progressLabel: "Expenses In Budget",
//       progressAmount: 3100.0,
//       icon: <ShoppingBagIcon style={{ color: "#FF6B9D", fontSize: "20px" }} />,
//       iconBg: "#FF6B9D",
//     },
//     {
//       title: "Bills Budget",
//       label: "Bills",
//       labelColor: "#60A5FA",
//       expected: "Budget",
//       expectedAmount: 96.0,
//       progress: 0,
//       progressLabel: "Bills In Budget",
//       progressAmount: 96.0,
//       icon: <DescriptionIcon style={{ color: "#60A5FA", fontSize: "20px" }} />,
//       iconBg: "#60A5FA",
//     },
//     {
//       title: "Debts Payment Goal",
//       label: "Debts Paid",
//       labelColor: "#F59E0B",
//       expected: "Goal",
//       expectedAmount: 300.0,
//       progress: 0,
//       progressLabel: "Debts Unpaid",
//       progressAmount: 300.0,
//       icon: <CreditCardIcon style={{ color: "#F59E0B", fontSize: "20px" }} />,
//       iconBg: "#F59E0B",
//     },
//     {
//       title: "Savings Goal",
//       label: "Money Saved",
//       labelColor: "#A78BFA",
//       expected: "Goal",
//       expectedAmount: 2654.0,
//       progress: 0,
//       progressLabel: "Savings Under Goal",
//       progressAmount: 2654.0,
//       icon: <SavingsIcon style={{ color: "#A78BFA", fontSize: "20px" }} />,
//       iconBg: "#A78BFA",
//     },
//   ]

const BudgetStatsCards = ({apiData}) => {
const [budgetCards, setbudgetCards] = useState([]);

  useEffect(() => {
  const data = apiData?.api3;

  if (!data) return;

  setbudgetCards([
    {
      title: "Expected Income",
      label: "Money In",
      labelColor: "#4ECDC4",
      expected: "Expected",
      expectedAmount: data.expectedIncome ?? 0,
      moneyValues: data.moneyIn ?? 0,
      progress: Number(data.incomeProgress?.toFixed(2)) ?? 0,
      icon: <AttachMoneyIcon style={{ color: "#4ECDC4", fontSize: "20px" }} />,
      iconBg: "#4ECDC4",
    },
    {
      title: "Expenses Budget",
      label: "Expenses",
      labelColor: "#FF6B9D",
      expected: "Budget",
      expectedAmount: data.expenseBudget ?? 0,
      moneyValues: data.actualExpense ?? 0,
      progress: Number(data.expenseProgress?.toFixed(2)) ?? 0,
      icon: <ShoppingBagIcon style={{ color: "#FF6B9D", fontSize: "20px" }} />,
      iconBg: "#FF6B9D",
    },
    {
      title: "Savings Goal",
      label: "Money Saved",
      labelColor: "#A78BFA",
      expected: "Goal",
      expectedAmount: data.savingsGoal ?? 0,
      moneyValues: data.savings ?? 0,
      progress: Number(data.savingsProgress?.toFixed(2)) ?? 0,
      icon: <SavingsIcon style={{ color: "#A78BFA", fontSize: "20px" }} />,
      iconBg: "#A78BFA",
    },
  ]);
}, [apiData?.api3]);

  return (
    <div className="budget-stats-container">
      {budgetCards && budgetCards?.length > 0 ? budgetCards?.map((card, index) => (
        <div
          key={index}
          className="budget-card"
          style={{ animationDelay: `${index * 0.1}s` }}
        >
          <div className="budget-card-header">
            <div
              className="header-icon"
              style={{
                background: `${card.iconBg}15`,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              {card.icon}
            </div>
            <h3 className="budget-card-title">{card.title}</h3>
          </div>

          <div className="budget-card-amounts">
            <div className="amount-item">
              <span className="amount-label" style={{ color: card.labelColor }}>
                {card.label}
              </span>
              <span className="amount-value">₹ {card.moneyValues?.toLocaleString("en-IN")}</span>
            </div>
            {
              index != 2 ?
            <div className="amount-item">
              <span className="amount-label">{card.expected}</span>
              <span className="amount-value">
                ₹{" "}
                {card.expectedAmount.toLocaleString("en-IN", {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}
              </span>
            </div>
            :""}
          </div>
                {
                  index != 2 ?
                 
          <div className="budget-progress-section">
            <div className="progress-header">
              <span className="progress-percentage">{card.progress}%</span>
              <span className="progress-text">Progress this month</span>
            </div>

            {/* <div className="progress-details">
              <p className="progress-label">{card.progressLabel}</p>
              <p className="progress-amount">
                ₹{" "}
                {card.progressAmount.toLocaleString("en-IN", {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}
              </p>
            </div> */}
          </div>
          :""}

          <div
            className="budget-card-icon"
            style={{
              background: `${card.iconBg}15`,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            {card.icon}
          </div>
        </div>
      )):""}
    </div>
  );
};

export default BudgetStatsCards;
